export {
  about,
  nav,
  partners,
  site,
  socials,
  stats,
  testimonials,
  whyChooseUs,
} from "./site";
export {
  categories,
  getCategory,
  getFeaturedProducts,
  getProduct,
  getProductsByCategory,
  getRelatedProducts,
  products,
} from "./products";
export { gallery } from "./gallery";
export { productDetailIdRedirects, productIdRedirects } from "./redirects";
